import { createSlice } from '@reduxjs/toolkit';

const initialState={
    globalconfigurations:null
}
export const globalConfigSlice = createSlice({
  name: 'globalconfigurations',
  initialState,
  reducers: {

    setGlobalConfig: (state, action) => {
      state.globalconfigurations = action.payload;
      
      
    },
    setLogoutGlobalConfig: (state,action)=>{
      state.globalconfigurations=null
    }
  },
});
export const {  setGlobalConfig,setLogoutGlobalConfig} = globalConfigSlice.actions;

export default globalConfigSlice.reducer;
